import React from 'react';
import bannerBg from '../assets/img/page-banner.jpg';
import PageBanner from '../components/PageBanner';
import Header3 from '../components/Header3';
import Footer3 from '../components/Footer3';
import { Helmet } from 'react-helmet';
import CheckOutForm from '../components/ContactForm/CheckOutForm';

function CartForm({bannerHeading,currentPage,formTitle,formHeading, url}) {
    return (
        <>
            <Helmet>
                <title>{`Testfabrics.com: ${currentPage.slice(0,60).toUpperCase()}`}</title>
            </Helmet>
            <Header3 />
            <PageBanner bannerBg={bannerBg} heading={''} currentPage={currentPage} />
            <br/>
            <CheckOutForm title={formTitle} heading={formHeading} url={url}/>
            <Footer3 />
        </>
    );
}

export default CartForm;
